<style>
  body {
    transition: opacity 0.3s ease-out;
  }

  .popup-mahila {
    background-color: white;
    padding: 40px;
    border-radius: 12px;
    margin-top: 20px;
  }

  #tarot-draw {
    text-align: center;
  }

  .card-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 250px;
    position: relative;
}

.card {
  width: 100px;
  height: 150px;
  perspective: 1000px;
  cursor: pointer;
  position: absolute;
  transition: all 0.3s ease;
  margin-left: -50px;
}

.card:nth-child(1) { left: 20%; z-index: 1; }
.card:nth-child(2) { left: 25%; z-index: 2; }
.card:nth-child(3) { left: 30%; z-index: 3; }
.card:nth-child(4) { left: 35%; z-index: 4; }
.card:nth-child(5) { left: 40%; z-index: 5; }
.card:nth-child(6) { left: 45%; z-index: 6; }
.card:nth-child(7) { left: 50%; z-index: 7; }
.card:nth-child(8) { left: 55%; z-index: 8; }
.card:nth-child(9) { left: 60%; z-index: 9; }
.card:nth-child(10) { left: 65%; z-index: 10; }
.card:nth-child(11) { left: 70%; z-index: 11; }
.card:nth-child(12) { left: 75%; z-index: 12; }

.card:hover {
    transform: scale(1.1);
    z-index: 100;
}

.card-inner {
    width: 100%;
    height: 100%;
    transition: transform 0.6s;
    transform-style: preserve-3d;
    position: relative;
}

.card.flipped .card-inner {
    transform: rotateY(180deg);
}

.card-front,
.card-back {
    position: absolute;
    width: 100%;
    height: 100%;
    backface-visibility: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    border-radius: 10px;
    box-shadow: 0 4px 6px rgba(0,0,0,0.1);
}

.card-front {
    background-color: #444;
    color: #fff;
}

.card-back {
    transform: rotateY(180deg);
    background-color: transparent;
}

.card img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 10px;
}

/* Responsividade */
@media (max-width: 768px) {
    .card-container {
        height: 200px;
    }
    
    .card {
        width: 80px;
        height: 120px;
    }

    /* Repita para outros elementos */
}

.card.flipped {
  transform: scale(1.5) translateY(-50px);
  z-index: 200;
  box-shadow: 0 10px 20px rgba(0,0,0,0.3);
  transition: all 0.3s ease-out;
}

@keyframes sparkle {
  0% {
      transform: scale(0);
      opacity: 0;
  }
  50% {
      transform: scale(1.2);
      opacity: 1;
  }
  100% {
      transform: scale(2);
      opacity: 0;
  }
}

@keyframes shine {
  0% {
      background-position: -100% 0;
  }
  100% {
      background-position: 200% 0;
  }
}

.card.selected {
  transform: scale(1.5) translateY(-50px);
  z-index: 200;
  box-shadow: 0 10px 20px rgba(0,0,0,0.3);
  animation: shine 1.5s infinite linear;
  position: relative;
  overflow: visible;
}

.card.selected::before {
  content: '';
  position: absolute;
  top: -20px;
  left: -20px;
  right: -20px;
  bottom: -20px;
  background: linear-gradient(
      45deg, 
      transparent, 
      rgba(255,255,255,0.3), 
      transparent
  );
  animation: shine 1.5s infinite linear;
}

.sparkle {
  position: absolute;
  width: 10px;
  height: 10px;
  background-color: gold;
  border-radius: 50%;
  animation: sparkle 0.5s ease-out;
  pointer-events: none;
}

@keyframes fadeOut {
  from {
      opacity: 1;
      visibility: visible;
  }
  to {
      opacity: 0;
      display: none;
  }
}

.card-container.fade-out {
  animation: fadeOut 0.5s ease-out forwards;
}


.carta-imagem {
  max-width: 300px;
  max-height: 450px;
  object-fit: contain;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
}

.carta-descricao {
  max-width: 800px;
  margin: 0 auto;
  padding: 0 15px;
}

.carta-descricao::-webkit-scrollbar {
  width: 8px;
}

.carta-descricao::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.carta-descricao::-webkit-scrollbar-thumb {
  background: #42b983;
  border-radius: 4px;
}

.card-title {
  color: #2c3e50;
  font-size: 2rem;
}

.text-primary {
  color: #42b983 !important;
  border-bottom: 2px solid #42b983;
  padding-bottom: 10px;
  margin-bottom: 15px;
}

.card-text {
  line-height: 1.6;
  color: #333;
  text-align: left;
}

@keyframes shuffleCircle {
  0% { 
    transform: rotate(0deg) translate(0, 0);
    opacity: 1;
  }
  50% { 
    transform: rotate(360deg) translate(200px, 200px);
    opacity: 0.5;
  }
  100% { 
    transform: rotate(0deg) translate(0, 0);
    opacity: 1;
  }
}

.card-container {
  transition: all 0.5s ease;
}

.card {
  transition: all 0.5s ease;
}
</style>

<template>
  <div>
    <div class="container-fluid fundo-mahila">
      <div class="row">
        <div class="col-4"></div>
        <div class=" col-md-4 col-sm-12 popup-mahila">
          <div>
            <p style="text-align: center;" v-if="stepOne">Para receber sua tiragem. Preencha o formulário abaixo.</p>
            <form v-if="this.enviouForm == false && this.loading == false">
              <div class="form-group">
                <div v-if="stepOne">
                  <label for="email">Insira o e-mail que deseja receber o resultado</label>
                  <input type="email" id="email" class="form-control" v-model="email">
                  <br>
                  <label for="pergunta">Qual a sua pergunta?</label>
                  <input type="text" id="pergunta" class="form-control" v-model="pergunta">
                  <br>
                  <div>
                    <btn class="btn btn-success" style="display: flex;justify-content: center;" @click="nextStep">Avançar</btn>
                  </div>
                </div>
                <div v-if="stepTwo">
                  <div id="tarot-draw">
                    <p>Escolha a sua carta</p>
                    <div class="card-container">
                      <div v-for="(card, index) in cards" :key="index" class="card"
                      :class="{ flipped: selectedCards.some(selected => selected.id === card.id) }" @click="selectCard(card, $event)">
                        <div class="card-inner">
                          <div class="card-front"><img 
                            src="../assets/costas-carta.jpg" 
                            style="width: 132px; height: 225px; object-fit: cover;"
                          /></div>
                          <div class="card-back">
                            <img :src="card.image" :alt="card.name" />
                          </div>
                        </div>
                      </div>
                      <button type="button" @click="embaralharCartas" class="btn-embaralhar btn btn-primary mb-3">
                        Embaralhar Cartas
                      </button>
                    </div>
                  </div>
                </div>
                <div v-if="selectedCards.length > 0" class="carta-detalhes-container mt-4">
                  <div class="container-fluid">
                    <div class="row">
                      <div class="col-12">
                        <div class="row g-0">
                          <div class="col-12 d-flex flex-column align-items-center p-3">
                            <img 
                              :src="selectedCards[0].image" 
                              :alt="selectedCards[0].name" 
                              class="carta-imagem mb-3"
                            >
                            <h2 class="card-title text-center mb-4">{{ selectedCards[0].name }}</h2>
                            
                            <div class="carta-descricao text-center">
                              <div class="mb-4">
                                <p class="card-text" v-html="selectedCards[0].messages"></p>
                                <br>
                                <br>
                                <button type="button" @click="recarregarPagina" class="btn btn-warning">
                                Fazer Nova Tiragem
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <hr>
          <h3 style="text-align: center; color: red; font-weight: bold">Precisa de suporte?</h3>
          <p>
            Não se preocupe, envie um e-mail com o seu Nome Completo, CPF e conte o que está acontecendo para podermos
            ajudar.
            <br><br>
            O e-mail do meu suporte é: contato@mahilaluz.com (note que o nosso e-mail não tem o ".br" no final)
          </p>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
  import axios from 'axios';

  export default {
    data() {
      return {
        email: '',
        pergunta: '',
        enviouForm: false,
        tags: null,
        imgEmail: null,
        loading: false,
        maxSelections: 1,
        texto1: null,
        texto2: null,
        texto3: null,
        selectedCards: [],
        cards: [{
          id: 1,
          name: 'O Louco',
          image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/2/2b/Jean_Dodal_Tarot_trump_Fool.jpg/220px-Jean_Dodal_Tarot_trump_Fool.jpg',
          messages: `<p>O Louco representa o início de uma jornada cheia de possibilidades e potencial inexplorado. Esta carta simboliza a <b>inocência</b>, a <b>espontaneidade</b> e a <b>disposição para abraçar o desconhecido</b> com entusiasmo e coragem.</p>

          <h3>Reflexão sobre a energia da carta</h3>

          <p>Neste momento da sua vida, você pode estar sentindo um forte impulso para se aventurar em novos caminhos, livre de preocupações e expectativas. É como se estivesse prestes a dar um <i>salto de fé</i>, confiando que o universo irá ampará-lo. Esta energia traz consigo tanto oportunidades quanto riscos.</p>

          <h3>Manifestações na vida real</h3>

          <ul>
            <li>Você pode sentir uma vontade irresistível de largar tudo e recomeçar do zero</li>
            <li>Novas ideias e projetos não convencionais podem estar surgindo em sua mente</li>
            <li>Existe a possibilidade de você estar ignorando conselhos bem-intencionados dos outros</li>
            <li>Pode haver uma tendência a agir por impulso, sem considerar as consequências</li>
          </ul>

          <h3>Pontos para consideração</h3>

          <ol>
            <li><b>Equilíbrio entre liberdade e responsabilidade</b>: Como você pode abraçar o espírito aventureiro do Louco sem negligenciar suas obrigações?</li>
            <li><b>Sabedoria na inocência</b>: De que forma sua perspectiva única e despreocupada pode trazer soluções criativas para desafios atuais?</li>
            <li><b>Confiança x ingenuidade</b>: Reflita sobre a linha tênue entre confiar no fluxo da vida e ser ingênuo diante dos riscos reais.</li>
            <li><b>O valor da jornada</b>: Lembre-se que às vezes o crescimento está no processo, não no destino. Como você pode apreciar cada passo do caminho?</li>
            <li><b>Libertação de expectativas</b>: Que bagagem emocional ou mental você precisa deixar para trás para embarcar nesta nova fase com leveza?</li>
          </ol>

          <p>A energia do Louco o convida a <b>abraçar o novo com coragem e otimismo</b>. Permita-se sonhar grande e dar os primeiros passos em direção ao desconhecido, mas mantenha um pé no chão para não tropeçar em obstáculos evitáveis. A verdadeira sabedoria está em saber quando seguir o coração e quando ouvir a voz da razão.</p>`
        },
          {
            id: 2,
            name: 'O Mago',
            image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/Jean_Dodal_Tarot_trump_01.jpg/220px-Jean_Dodal_Tarot_trump_01.jpg',
            messages: `<p>O Mago simboliza o poder da <b>manifestação</b>, da <b>criatividade</b> e da <b>habilidade</b>. Esta carta representa a capacidade de canalizar energias superiores e transformá-las em realidade tangível, unindo o mundo espiritual ao material.</p>
            <h3>Reflexão sobre a energia da carta</h3>

            <p>Neste momento, você está diante de um portal de possibilidades infinitas. O Mago lhe convida a reconhecer seus talentos únicos e a usá-los de forma consciente e produtiva. É hora de <i>transformar ideias em ação</i> e potencial em realização.</p>

            <h3>Manifestações na vida real</h3>

            <ul>
              <li>Você pode sentir uma súbita clareza mental e foco intenso em seus objetivos</li>
              <li>Novas oportunidades para demonstrar suas habilidades podem surgir</li>
              <li>Há uma forte sensação de que você tem todos os recursos necessários ao seu alcance</li>
              <li>Você pode se sentir inspirado a iniciar novos projetos ou aprender novas habilidades</li>
            </ul>

            <h3>Pontos para consideração</h3>

            <ol>
              <li><b>Poder e responsabilidade</b>: Como você pode usar seus talentos de forma ética e benéfica para si e para os outros?</li>
              <li><b>Integração de elementos</b>: De que maneira você pode equilibrar sua intuição com sua lógica para alcançar melhores resultados?</li>
              <li><b>Manifestação consciente</b>: Quais são seus verdadeiros desejos e como você pode alinhá-los com suas ações diárias?</li>
              <li><b>Domínio pessoal</b>: Em quais áreas da sua vida você precisa assumir mais controle e direcionamento?</li>
              <li><b>Transmutação</b>: Como você pode transformar desafios em oportunidades de crescimento e sucesso?</li>
            </ol>

            <p>O Mago o lembra que você é o <b>criador da sua própria realidade</b>. Seus pensamentos, palavras e ações são ferramentas poderosas de manifestação. Use-as com sabedoria e intenção. Confie em suas habilidades, mas também esteja aberto para aprender e evoluir constantemente. O verdadeiro poder do Mago está na sua capacidade de conectar o céu e a terra, o sonho e a realidade.</p>

            <h3>Reflexão final</h3>

            <p><i>"Como um Mago habilidoso, você tem o poder de transformar o ordinário em extraordinário. Que tipo de magia você escolherá criar em sua vida hoje?"</i></p>`,
          },
          {
            id: 3,
            name: 'A Sacerdotisa',
            image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/92/Jean_Dodal_Tarot_trump_02.jpg/200px-Jean_Dodal_Tarot_trump_02.jpg',
            messages: `<p>A Sacerdotisa representa a <b>intuição profunda</b>, o <b>mistério</b> e o <b>conhecimento oculto</b>. Esta carta simboliza a sabedoria interior, a compreensão silenciosa e o poder do subconsciente.</p>

            <h3>Reflexão sobre a energia da carta</h3>

            <p>Neste momento, você é convidado a mergulhar nas profundezas do seu ser. A Sacerdotisa sussurra segredos antigos e verdades ocultas, incentivando-o a <i>confiar na voz suave da sua intuição</i>. É um tempo de introspecção, onde as respostas que você busca estão dentro de você.</p>

            <h3>Manifestações na vida real</h3>

            <ul>
              <li>Você pode sentir uma forte atração por conhecimentos esotéricos ou espirituais</li>
              <li>Sonhos vívidos ou insights repentinos podem se tornar mais frequentes</li>
              <li>Há uma tendência a buscar solidão e silêncio para reflexão</li>
              <li>Você pode se sentir mais sensível às energias ao seu redor</li>
              <li>Segredos ou informações ocultas podem vir à tona</li>
            </ul>

            <h3>Pontos para consideração</h3>

            <ol>
              <li><b>Confiança na intuição</b>: Como você pode cultivar uma relação mais próxima com sua voz interior?</li>
              <li><b>Equilíbrio entre razão e intuição</b>: De que forma você pode integrar seu conhecimento intuitivo com sua lógica?</li>
              <li><b>Segredos e revelações</b>: Existe alguma verdade que você está evitando encarar? O que ela pode lhe ensinar?</li>
              <li><b>Sabedoria silenciosa</b>: Em quais áreas da sua vida você precisa observar mais e agir menos?</li>
              <li><b>Mistérios da vida</b>: Como você pode abraçar o desconhecido com mais serenidade e menos medo?</li>
            </ol>

            <h3>Práticas sugeridas</h3>

            <ul>
              <li>Dedique tempo à meditação ou contemplação silenciosa</li>
              <li>Mantenha um diário de sonhos para explorar seu subconsciente</li>
              <li>Pratique a leitura de tarô ou outras formas de adivinhação para desenvolver sua intuição</li>
              <li>Estude temas místicos ou espirituais que lhe interessem</li>
              <li>Crie um espaço sagrado em sua casa para reflexão e conexão interior</li>
            </ul>

            <p>A Sacerdotisa o lembra que <b>nem todas as verdades podem ser expressas em palavras</b>. Algumas devem ser sentidas, intuídas e experimentadas. Confie no processo de descoberta interior e permita-se ser guiado pelo conhecimento silencioso que reside em seu coração.</p>

            <h3>Reflexão final</h3>

            <p><i>"No silêncio entre seus pensamentos, nas pausas entre suas palavras, nos espaços entre suas ações - é lá que a Sacerdotisa revela seus segredos. Você está pronto para escutar?"</i></p>`,
          },
          {
            id: 4,
            name: 'A Imperatriz',
            image: 'https://miro.medium.com/v2/resize:fit:1400/1*FFsGHyY9BBzvPMR0Wq6NXA.jpeg',
            messages: `<p>A Imperatriz encarna a <b>fertilidade</b>, a <b>abundância</b> e o <b>poder criativo feminino</b>. Esta carta representa a força nutridora da natureza, a maternidade e a capacidade de dar vida às ideias e projetos.</p>

            <h3>Reflexão sobre a energia da carta</h3>

            <p>Neste momento, você está conectado com uma poderosa energia de criação e crescimento. A Imperatriz o convida a <i>abraçar sua capacidade de nutrir e cultivar</i>, seja em relação a projetos, relacionamentos ou a si mesmo. É um período fértil para manifestar seus desejos e cuidar do que você valoriza.</p>

            <h3>Manifestações na vida real</h3>

            <ul>
              <li>Você pode sentir um aumento na sua criatividade e inspiração</li>
              <li>Oportunidades de crescimento e expansão podem surgir em várias áreas da vida</li>
              <li>Há uma forte conexão com a natureza e os ciclos naturais</li>
              <li>Você pode se sentir mais maternal ou paternal, mesmo que não tenha filhos</li>
              <li>Projetos e ideias podem florescer com facilidade e abundância</li>
            </ul>

            <h3>Pontos para consideração</h3>

            <ol>
              <li><b>Nutrição e cuidado</b>: Como você pode nutrir melhor a si mesmo e aos outros em sua vida?</li>
              <li><b>Criatividade e expressão</b>: Quais ideias ou projetos estão prontos para serem manifestados?</li>
              <li><b>Conexão com a natureza</b>: De que forma você pode se alinhar mais com os ritmos naturais da vida?</li>
              <li><b>Abundância e gratidão</b>: Como você pode reconhecer e apreciar a abundância já presente em sua vida?</li>
              <li><b>Equilíbrio entre dar e receber</b>: Você está permitindo-se receber tanto quanto dá aos outros?</li>
            </ol>

            <h3>Práticas sugeridas</h3>

            <ul>
              <li>Dedique tempo a atividades criativas que o inspirem</li>
              <li>Cultive um jardim ou cuide de plantas em casa</li>
              <li>Pratique a gratidão diariamente, reconhecendo a abundância em sua vida</li>
              <li>Nutra seu corpo com alimentos saudáveis e naturais</li>
              <li>Explore sua sensualidade e conexão com seu corpo</li>
            </ul>

            <h3>Afirmação da Imperatriz</h3>

            <p><i>"Eu sou um canal de criatividade e abundância. Nutro meus sonhos com amor e paciência, sabendo que eles florescerão no momento certo."</i></p>

            <p>A Imperatriz o lembra que você possui um <b>poder inato de criar e nutrir</b>. Confie em sua capacidade de dar vida às suas ideias e cuidar delas com amor e atenção. Esteja aberto para receber a abundância que o universo tem a oferecer, sabendo que você merece prosperar em todos os aspectos da sua vida.</p>

            <h3>Reflexão final</h3>

            <p><i>"Como a Imperatriz em seu trono de fertilidade, você tem o poder de criar mundos. Que sementes você escolherá plantar hoje, sabendo que cada uma tem o potencial de se tornar um vasto e belo jardim?"</i></p>`,
          },
          {
            id: 5,
            name: 'O Imperador',
            image: 'https://miro.medium.com/v2/resize:fit:1400/1*P2x0iaZigJ7dgkDCJOSdRw.jpeg',
            messages: `<p>O Imperador simboliza a <b>autoridade</b>, a <b>estrutura</b> e o <b>poder masculino</b>. Esta carta representa liderança, estabilidade e a capacidade de criar ordem a partir do caos.</p>

            <h3>Reflexão sobre a energia da carta</h3>

            <p>Neste momento, você é chamado a assumir o controle e estabelecer ordem em sua vida. O Imperador o convida a <i>exercer sua autoridade com sabedoria e firmeza</i>, criando estruturas sólidas para sustentar seus objetivos e aspirações. É um período para agir com determinação e confiança.</p>

            <h3>Manifestações na vida real</h3>

            <ul>
              <li>Você pode sentir um forte desejo de organizar e estruturar diferentes aspectos da sua vida</li>
              <li>Oportunidades de liderança ou de assumir mais responsabilidades podem surgir</li>
              <li>Há uma tendência a buscar estabilidade e segurança em suas decisões</li>
              <li>Você pode se sentir mais assertivo e confiante em suas opiniões e ações</li>
              <li>Questões relacionadas a figuras de autoridade ou paternidade podem vir à tona</li>
            </ul>

            <h3>Pontos para consideração</h3>

            <ol>
              <li><b>Liderança e responsabilidade</b>: Como você pode exercer sua autoridade de forma justa e benéfica?</li>
              <li><b>Equilíbrio entre firmeza e flexibilidade</b>: De que maneira você pode manter a estrutura sem se tornar rígido demais?</li>
              <li><b>Criação de sistemas eficientes</b>: Quais áreas da sua vida precisam de mais organização e planejamento?</li>
              <li><b>Uso do poder</b>: Como você pode usar sua influência para criar um impacto positivo?</li>
              <li><b>Tradição vs. inovação</b>: Como equilibrar o respeito pelas tradições com a necessidade de adaptação e mudança?</li>
            </ol>

            <h3>Práticas sugeridas</h3>

            <ul>
              <li>Estabeleça metas claras e crie um plano de ação para alcançá-las</li>
              <li>Pratique a assertividade em suas comunicações e decisões</li>
              <li>Organize seu espaço físico para refletir a ordem que deseja em sua vida</li>
              <li>Estude técnicas de liderança e gestão para aprimorar suas habilidades</li>
              <li>Reflita sobre suas relações com figuras de autoridade e como isso influencia sua própria liderança</li>
            </ul>

            <h3>Afirmação do Imperador</h3>

            <p><i>"Eu sou capaz de liderar com sabedoria e compaixão. Crio estruturas sólidas que me permitem alcançar meus objetivos e inspirar os outros."</i></p>

            <p>O Imperador o lembra que você possui a <b>capacidade inata de criar ordem e estabilidade</b> em sua vida. Confie em sua autoridade interior e use-a com discernimento. Lembre-se que verdadeira força vem não apenas do poder, mas da sabedoria em como aplicá-lo.</p>

            <h3>Reflexão final</h3>

            <p><i>"Como o Imperador em seu trono, você tem o poder de moldar seu reino. Que tipo de líder você escolhe ser, e que legado deseja deixar para aqueles que o seguem?"</i></p>`,
          },
          {
            id: 6,
            name: 'O Hierofante',
            image: 'https://miro.medium.com/v2/resize:fit:1400/1*NgsNrrgPJQq7KiUiUpdOCQ.jpeg',
            messages: `<p>O Hierofante simboliza a <b>tradição</b>, a <b>espiritualidade institucionalizada</b> e a <b>sabedoria convencional</b>. Esta carta representa a busca por conhecimento através de caminhos estabelecidos, a conformidade com normas sociais e a orientação espiritual.</p>

            <h3>Reflexão sobre a energia da carta</h3>

            <p>Neste momento, você é convidado a explorar as tradições e os ensinamentos estabelecidos que podem guiar seu caminho. O Hierofante o encoraja a <i>buscar sabedoria em fontes confiáveis e respeitadas</i>, sejam elas instituições educacionais, religiosas ou culturais. É um período para considerar a importância das estruturas e crenças que moldam nossa sociedade.</p>

            <h3>Manifestações na vida real</h3>

            <ul>
              <li>Você pode sentir um forte desejo de aprofundar seus estudos em áreas tradicionais ou espirituais</li>
              <li>Questões relacionadas à fé, crenças ou valores morais podem se tornar mais proeminentes</li>
              <li>Há uma tendência a buscar orientação de mentores, professores ou líderes espirituais</li>
              <li>Você pode se sentir atraído por rituais, cerimônias ou práticas convencionais</li>
              <li>Situações que envolvem conformidade com regras ou expectativas sociais podem surgir</li>
            </ul>

            <h3>Pontos para consideração</h3>

            <ol>
              <li><b>Tradição vs. inovação</b>: Como você pode honrar as tradições enquanto permanece aberto a novas ideias?</li>
              <li><b>Sabedoria coletiva</b>: De que maneira os ensinamentos estabelecidos podem enriquecer sua jornada pessoal?</li>
              <li><b>Moralidade e ética</b>: Quais valores fundamentais guiam suas decisões e ações?</li>
              <li><b>Mentoria e aprendizado</b>: Como você pode se beneficiar da orientação de outros sem perder sua autonomia?</li>
              <li><b>Conformidade vs. individualidade</b>: Onde você precisa se alinhar com as normas sociais e onde pode expressar sua unicidade?</li>
            </ol>

            <h3>Práticas sugeridas</h3>

            <ul>
              <li>Explore textos sagrados ou filosóficos que ressoem com você</li>
              <li>Participe de uma cerimônia ou ritual significativo para sua cultura ou crenças</li>
              <li>Busque a orientação de um mentor ou conselheiro respeitado em sua área de interesse</li>
              <li>Estude a história e as tradições de sua família ou comunidade</li>
              <li>Reflita sobre seus próprios valores e como eles se alinham com as normas sociais</li>
            </ul>

            <h3>Afirmação do Hierofante</h3>

            <p><i>"Eu estou aberto para aprender com a sabedoria ancestral e as tradições estabelecidas. Integro esse conhecimento com minha própria experiência para encontrar um caminho significativo."</i></p>

            <p>O Hierofante o lembra que há <b>valor na sabedoria coletiva e nas estruturas estabelecidas</b>. Ao mesmo tempo, encoraja você a questionar e interpretar essas tradições de forma que façam sentido para sua jornada pessoal. Busque o equilíbrio entre respeitar o conhecimento estabelecido e manter sua autenticidade individual.</p>

            <h3>Reflexão final</h3>

            <p><i>"Como um estudante diante do Hierofante, que lições você está pronto para aprender? E como essas lições podem se tornar a base para sua própria sabedoria e ensinamentos futuros?"</i></p>`,
          },
          {
            id: 7,
            name: 'Os Enamorados',
            image: 'https://miro.medium.com/v2/resize:fit:720/format:webp/1*s3XkIphxMPC3Jeet0S0TwQ.jpeg',
            messages: `<p>Os Enamorados simbolizam <b>amor</b>, <b>harmonia</b>, <b>relacionamentos</b> e <b>escolhas importantes</b>. Esta carta representa a união de opostos, a atração mútua e a necessidade de tomar decisões baseadas no coração e na mente.</p>

            <h3>Reflexão sobre a energia da carta</h3>

            <p>Neste momento, você está diante de uma encruzilhada significativa em sua vida. Os Enamorados o convidam a <i>examinar seus valores, desejos e conexões mais profundas</i>. É um período para considerar cuidadosamente suas escolhas, buscando um equilíbrio entre razão e emoção, dever e desejo.</p>

            <h3>Manifestações na vida real</h3>

            <ul>
              <li>Você pode estar experimentando uma forte atração ou conexão com alguém</li>
              <li>Uma decisão importante relacionada a relacionamentos ou parcerias pode estar se aproximando</li>
              <li>Questões de comprometimento e valores pessoais podem vir à tona</li>
              <li>Você pode sentir a necessidade de integrar diferentes aspectos de si mesmo</li>
              <li>Dilemas morais ou éticos podem requerer sua atenção e resolução</li>
            </ul>

            <h3>Pontos para consideração</h3>

            <ol>
              <li><b>Escolhas do coração</b>: Como suas decisões atuais se alinham com seus valores e desejos mais profundos?</li>
              <li><b>Equilíbrio nas relações</b>: De que maneira você pode cultivar mais harmonia e reciprocidade em seus relacionamentos?</li>
              <li><b>Integração de opostos</b>: Como você pode reconciliar aspectos aparentemente contraditórios em sua vida ou personalidade?</li>
              <li><b>Comprometimento vs. liberdade</b>: Onde você precisa se comprometer mais e onde precisa manter sua independência?</li>
              <li><b>Alinhamento com o eu superior</b>: Suas ações e escolhas estão em harmonia com sua verdadeira essência?</li>
            </ol>

            <h3>Práticas sugeridas</h3>

            <ul>
              <li>Faça uma lista de prós e contras para uma decisão importante, incluindo considerações emocionais e racionais</li>
              <li>Pratique a comunicação aberta e honesta em seus relacionamentos</li>
              <li>Explore técnicas de integração de polaridades, como meditação ou trabalho com arquetipos</li>
              <li>Reflita sobre seus valores pessoais e como eles influenciam suas escolhas</li>
              <li>Dedique tempo para atividades que nutram tanto sua mente quanto seu coração</li>
            </ul>

            <h3>Afirmação dos Enamorados</h3>

            <p><i>"Eu escolho com sabedoria e amor, honrando minha verdade interior. Estou aberto para a harmonia e o equilíbrio em todas as minhas relações."</i></p>

            <p>Os Enamorados o lembram que as <b>escolhas mais poderosas são aquelas que integram mente e coração</b>. Esta carta o encoraja a buscar harmonia em suas relações e dentro de si mesmo. Confie em sua capacidade de fazer escolhas alinhadas com seu eu superior, mesmo quando o caminho não é fácil ou óbvio.</p>

            <h3>Reflexão final</h3>

            <p><i>"No jardim dos Enamorados, cada escolha é uma semente plantada para o futuro. Que flores você deseja ver florescer em sua vida? E que compromissos você está disposto a fazer para nutri-las?"</i></p>`,
          },
          {
            id: 8,
            name: 'O Carro',
            image: 'https://miro.medium.com/v2/resize:fit:1400/1*pTXDdKamO-g-R21Q6Tlbdw.jpeg',
            messages: `<p>O Carro simboliza <b>determinação</b>, <b>controle</b>, <b>vontade</b> e <b>vitória</b>. Esta carta representa o triunfo sobre os obstáculos através da força de vontade, foco e autocontrole. É um símbolo de progresso, ambição e a capacidade de dirigir sua vida na direção desejada.</p>

            <h3>Reflexão sobre a energia da carta</h3>

            <p>Neste momento, você está pronto para assumir as rédeas de sua vida e avançar com confiança. O Carro o convida a <i>canalizar sua energia e determinação para superar desafios e alcançar seus objetivos</i>. É um período para manter o foco, equilibrar forças opostas e seguir em frente com convicção.</p>

            <h3>Manifestações na vida real</h3>

            <ul>
              <li>Você pode sentir um forte impulso para agir e fazer progresso em seus projetos</li>
              <li>Oportunidades de liderança ou de assumir maior controle sobre sua vida podem surgir</li>
              <li>Desafios que exigem determinação e foco podem aparecer em seu caminho</li>
              <li>Você pode se sentir mais confiante e capaz de superar obstáculos</li>
              <li>Questões relacionadas a viagens, mobilidade ou mudanças podem se tornar relevantes</li>
            </ul>

            <h3>Pontos para consideração</h3>

            <ol>
              <li><b>Direção e propósito</b>: Quais são seus objetivos mais importantes neste momento e como você pode avançar em direção a eles?</li>
              <li><b>Equilíbrio de forças</b>: Como você pode harmonizar diferentes aspectos de sua personalidade para alcançar seus objetivos?</li>
              <li><b>Autocontrole</b>: Em quais áreas de sua vida você precisa exercer mais disciplina e controle?</li>
              <li><b>Superação de obstáculos</b>: Quais desafios você está enfrentando e como pode usar sua determinação para superá-los?</li>
              <li><b>Movimento vs. estagnação</b>: Onde em sua vida você precisa tomar ação decisiva e avançar?</li>
            </ol>

            <h3>Práticas sugeridas</h3>

            <ul>
              <li>Estabeleça metas claras e crie um plano de ação detalhado para alcançá-las</li>
              <li>Pratique técnicas de visualização, imaginando-se superando obstáculos e alcançando o sucesso</li>
              <li>Implemente uma rotina diária que apoie seus objetivos e aumente sua disciplina</li>
              <li>Explore práticas de mindfulness para aumentar seu foco e autocontrole</li>
              <li>Reflita sobre áreas de sua vida onde você pode assumir mais responsabilidade e controle</li>
            </ul>

            <h3>Afirmação do Carro</h3>

            <p><i>"Eu sou o condutor da minha vida. Com foco, determinação e equilíbrio, avanço confiante em direção aos meus objetivos, superando todos os obstáculos em meu caminho."</i></p>

            <p>O Carro o lembra que você possui a <b>força e a capacidade de direcionar sua vida</b>. Esta carta o encoraja a manter o foco em seus objetivos, equilibrar forças opostas dentro de si e avançar com confiança. Confie em sua habilidade de superar desafios e alcançar a vitória através de sua determinação e autocontrole.</p>

            <h3>Reflexão final</h3>

            <p><i>"Como o condutor do Carro, você tem o poder de escolher seu destino e traçar seu caminho. Que jornada você escolherá empreender, e que vitórias você está determinado a conquistar ao longo do caminho?"</i></p>`,
          },
          {
            id: 9,
            name: 'A Justiça',
            image: 'https://miro.medium.com/v2/resize:fit:1400/1*Rod-eh--CSXpdjrq3NXH6A.jpeg',
            messages: `<p>A Justiça simboliza <b>equilíbrio</b>, <b>verdade</b>, <b>imparcialidade</b> e <b>consequências</b>. Esta carta representa a necessidade de tomar decisões justas, a busca pela verdade e o equilíbrio entre ação e reação. É um lembrete de que nossas escolhas têm consequências e que a honestidade e a integridade são fundamentais.</p>

            <h3>Reflexão sobre a energia da carta</h3>

            <p>Neste momento, você é chamado a examinar suas ações e decisões com um olhar imparcial. A Justiça o convida a <i>buscar a verdade, mesmo quando ela é desconfortável, e a agir com integridade em todas as situações</i>. É um período para equilibrar diferentes aspectos de sua vida e considerar cuidadosamente as consequências de suas escolhas.</p>

            <h3>Manifestações na vida real</h3>

            <ul>
              <li>Você pode se deparar com situações que exigem uma decisão imparcial e justa</li>
              <li>Questões legais ou contratuais podem se tornar relevantes em sua vida</li>
              <li>Pode haver uma necessidade de resolver conflitos ou disputas de maneira equilibrada</li>
              <li>Você pode sentir um forte desejo de buscar a verdade em uma situação complexa</li>
              <li>As consequências de ações passadas podem se manifestar no presente</li>
            </ul>

            <h3>Pontos para consideração</h3>

            <ol>
              <li><b>Equilíbrio e imparcialidade</b>: Como você pode abordar situações em sua vida com mais objetividade e equilíbrio?</li>
              <li><b>Ações e consequências</b>: De que maneira suas escolhas atuais podem impactar seu futuro?</li>
              <li><b>Verdade e honestidade</b>: Em quais áreas de sua vida você precisa ser mais honesto consigo mesmo e com os outros?</li>
              <li><b>Responsabilidade pessoal</b>: Como você pode assumir mais responsabilidade por suas ações e suas consequências?</li>
              <li><b>Resolução de conflitos</b>: Que conflitos em sua vida precisam ser abordados de maneira justa e equilibrada?</li>
            </ol>

            <h3>Práticas sugeridas</h3>

            <ul>
              <li>Pratique a escuta ativa em conversas, especialmente em situações de conflito</li>
              <li>Mantenha um diário de autorreflexão, examinando suas ações e decisões com honestidade</li>
              <li>Antes de tomar decisões importantes, liste os prós e contras de maneira imparcial</li>
              <li>Medite sobre o conceito de equilíbrio e como aplicá-lo em diferentes áreas de sua vida</li>
              <li>Estude princípios éticos e filosofias morais para aprofundar sua compreensão de justiça</li>
            </ul>

            <h3>Afirmação da Justiça</h3>

            <p><i>"Eu busco a verdade e ajo com integridade em todas as situações. Aceito a responsabilidade por minhas escolhas e me esforço para criar equilíbrio em minha vida e no mundo ao meu redor."</i></p>

            <p>A Justiça o lembra que <b>cada ação tem uma reação e que o universo busca o equilíbrio</b>. Esta carta o encoraja a agir com integridade, a buscar a verdade mesmo quando é difícil, e a considerar cuidadosamente as consequências de suas escolhas. Confie em sua capacidade de discernir o certo do errado e de tomar decisões justas e equilibradas.</p>

            <h3>Reflexão final</h3>

            <p><i>"Na balança da Justiça, cada pensamento, palavra e ação tem seu peso. Como você pode equilibrar a escala de sua vida, honrando a verdade e agindo com integridade em cada momento?"</i></p>`,
          },
          {
            id: 10,
            name: 'O Eremita',
            image: 'https://miro.medium.com/v2/resize:fit:1400/1*UWt7PakTz6Jecc4vSD4lSA.jpeg',
            messages: `<p>O Eremita simboliza <b>introspecção</b>, <b>busca interior</b>, <b>sabedoria</b> e <b>solidão</b>. Esta carta representa a jornada para dentro de si mesmo, a busca por respostas profundas e a necessidade de se afastar do mundo exterior para encontrar clareza e orientação interior.</p>

            <h3>Reflexão sobre a energia da carta</h3>

            <p>Neste momento, você é convidado a se voltar para dentro e buscar a sabedoria que reside em seu interior. O Eremita o encoraja a <i>fazer uma pausa, refletir profundamente e buscar respostas através da contemplação e do autoconhecimento</i>. É um período para se afastar do ruído do mundo e sintonizar-se com sua voz interior.</p>

            <h3>Manifestações na vida real</h3>

            <ul>
              <li>Você pode sentir uma forte necessidade de solidão e tempo para si mesmo</li>
              <li>Questões existenciais ou filosóficas podem ocupar seus pensamentos</li>
              <li>Pode surgir um desejo de simplificar sua vida e focar no que é verdadeiramente essencial</li>
              <li>Você pode se sentir atraído por práticas contemplativas como meditação ou mindfulness</li>
              <li>A busca por um mentor ou guia espiritual pode se tornar importante</li>
            </ul>

            <h3>Pontos para consideração</h3>

            <ol>
              <li><b>Autoconhecimento</b>: Que verdades sobre si mesmo você está pronto para descobrir ou enfrentar?</li>
              <li><b>Silêncio interior</b>: Como você pode criar mais espaço para o silêncio e a reflexão em sua vida diária?</li>
              <li><b>Sabedoria vs. conhecimento</b>: De que maneira você pode transformar seu conhecimento em sabedoria prática?</li>
              <li><b>Solidão vs. isolamento</b>: Como você pode cultivar uma solidão produtiva sem cair no isolamento prejudicial?</li>
              <li><b>Orientação interior</b>: Que perguntas profundas você precisa fazer a si mesmo neste momento de sua vida?</li>
            </ol>

            <h3>Práticas sugeridas</h3>

            <ul>
              <li>Dedique um tempo diário para a meditação ou contemplação silenciosa</li>
              <li>Faça um retiro solitário, mesmo que seja por um dia, para se reconectar consigo mesmo</li>
              <li>Mantenha um diário de reflexões pessoais, explorando seus pensamentos e sentimentos mais profundos</li>
              <li>Pratique a caminhada consciente na natureza, observando atentamente seu entorno e suas sensações internas</li>
              <li>Explore textos filosóficos ou espirituais que ressoem com sua busca interior</li>
            </ul>

            <h3>Afirmação do Eremita</h3>

            <p><i>"Eu me volto para dentro em busca de sabedoria e clareza. No silêncio e na solidão, encontro as respostas que procuro e a luz que guia meu caminho."</i></p>

            <p>O Eremita o lembra que <b>a verdadeira sabedoria vem do autoconhecimento e da reflexão profunda</b>. Esta carta o encoraja a confiar em sua luz interior, a buscar respostas dentro de si mesmo e a valorizar os momentos de solidão como oportunidades de crescimento e autodescoberta. Lembre-se de que às vezes é necessário se afastar do mundo para encontrar seu verdadeiro caminho.</p>

            <h3>Reflexão final</h3>

            <p><i>"Na jornada do Eremita, cada passo para dentro é um passo em direção à iluminação. Que verdades você descobrirá quando olhar profundamente em seu próprio ser, e como essa luz interior iluminará seu caminho no mundo exterior?"</i></p>`,
          },
          {
            id: 11,
            name: 'A Roda da Fortuna',
            image: 'https://miro.medium.com/v2/resize:fit:1400/1*FuMYLoOg3h2Cl3DtPo6tCg.jpeg',
            messages: `<p>A Roda da Fortuna simboliza <b>mudança</b>, <b>ciclos</b>, <b>destino</b> e <b>oportunidades</b>. Esta carta representa os altos e baixos da vida, a natureza cíclica das experiências e a interconexão entre escolha pessoal e forças maiores do universo.</p>

            <h3>Reflexão sobre a energia da carta</h3>

            <p>Neste momento, você está no limiar de uma mudança significativa. A Roda da Fortuna o convida a <i>reconhecer os padrões cíclicos em sua vida e a estar aberto às oportunidades que surgem com as mudanças</i>. É um período para abraçar o fluxo da vida, adaptando-se às circunstâncias em constante evolução e confiando no processo.</p>

            <h3>Manifestações na vida real</h3>

            <ul>
              <li>Você pode experimentar mudanças repentinas ou inesperadas em sua vida</li>
              <li>Oportunidades surpreendentes podem surgir, alterando o curso de seus planos</li>
              <li>Padrões repetitivos ou situações cíclicas podem se tornar mais evidentes</li>
              <li>Você pode sentir uma sensação de destino ou de estar no lugar certo na hora certa</li>
              <li>Questões de sorte, acaso ou sincronicidade podem se destacar em suas experiências</li>
            </ul>

            <h3>Pontos para consideração</h3>

            <ol>
              <li><b>Adaptabilidade</b>: Como você pode se tornar mais flexível e adaptável às mudanças em sua vida?</li>
              <li><b>Reconhecimento de padrões</b>: Que ciclos ou padrões repetitivos você identifica em sua jornada pessoal?</li>
              <li><b>Aproveitamento de oportunidades</b>: Como você pode estar mais atento e receptivo às oportunidades que surgem?</li>
              <li><b>Aceitação vs. controle</b>: Em que áreas da vida você precisa aceitar o fluxo natural e onde pode exercer mais influência?</li>
              <li><b>Perspectiva de longo prazo</b>: Como a compreensão dos ciclos da vida pode ajudar você a manter a esperança durante tempos difíceis?</li>
            </ol>

            <h3>Práticas sugeridas</h3>

            <ul>
              <li>Mantenha um diário de gratidão, focando nas oportunidades que cada dia traz</li>
              <li>Pratique a meditação da roda da vida para visualizar e equilibrar diferentes áreas de sua existência</li>
              <li>Estude os ciclos naturais (lunares, sazonais) e reflita sobre como eles se relacionam com sua vida</li>
              <li>Desenvolva uma prática de mindfulness para estar mais presente e consciente das mudanças ao seu redor</li>
              <li>Crie um "mapa de oportunidades", listando possibilidades positivas que podem surgir de situações desafiadoras</li>
            </ul>

            <h3>Afirmação da Roda da Fortuna</h3>

            <p><i>"Eu abraço as mudanças da vida com confiança e otimismo. Estou aberto às oportunidades que cada giro da roda traz, sabendo que cada experiência contribui para meu crescimento e evolução."</i></p>

            <p>A Roda da Fortuna o lembra que <b>a mudança é a única constante na vida</b>. Esta carta o encoraja a ver as mudanças não como ameaças, mas como oportunidades de crescimento e renovação. Confie no fluxo da vida, mantenha-se flexível e esteja atento às oportunidades que surgem, mesmo em momentos de desafio.</p>

            <h3>Reflexão final</h3>

            <p><i>"À medida que a Roda da Fortuna gira, cada momento é uma nova oportunidade para crescer, aprender e evoluir. Como você pode dançar com as mudanças da vida, transformando cada giro da roda em um passo em direção ao seu melhor self?"</i></p>`,
          },
          {
            id: 12,
            name: 'A Força',
            image: 'https://miro.medium.com/v2/resize:fit:1400/1*jQAD1A4D9tpTjRo5LDWDyA.jpeg',
            messages: `<p>A Força simboliza <b>coragem</b>, <b>compaixão</b>, <b>força interior</b> e <b>domínio suave</b>. Esta carta representa a capacidade de enfrentar desafios com graça e determinação, controlando impulsos através da gentileza e da paciência, em vez da força bruta.</p>

            <h3>Reflexão sobre a energia da carta</h3>

            <p>Neste momento, você é chamado a acessar sua força interior e a agir com coragem compassiva. A Força o convida a <i>enfrentar seus medos e desafios com determinação, mantendo a calma e a gentileza</i>. É um período para dominar suas emoções e impulsos, não através da repressão, mas através da compreensão e do equilíbrio.</p>

            <h3>Manifestações na vida real</h3>

            <ul>
              <li>Você pode se deparar com situações que exigem coragem e resiliência</li>
              <li>Oportunidades para praticar a paciência e a compaixão podem surgir</li>
              <li>Desafios emocionais ou psicológicos podem requerer sua atenção e superação</li>
              <li>Você pode sentir um aumento em sua confiança e força interior</li>
              <li>Situações que demandam autocontrole e domínio suave podem se apresentar</li>
            </ul>

            <h3>Pontos para consideração</h3>

            <ol>
              <li><b>Coragem compassiva</b>: Como você pode enfrentar seus medos com coragem, mantendo a compaixão por si mesmo e pelos outros?</li>
              <li><b>Domínio emocional</b>: De que maneira você pode gerenciar melhor suas emoções e impulsos sem reprimi-los?</li>
              <li><b>Força vs. poder</b>: Como você pode exercer sua força de forma construtiva e benéfica em suas relações e situações?</li>
              <li><b>Resiliência interior</b>: Quais recursos internos você pode acessar para superar desafios com graça?</li>
              <li><b>Equilíbrio entre firmeza e suavidade</b>: Em quais áreas da sua vida você precisa ser mais firme, e onde precisa ser mais gentil?</li>
            </ol>

            <h3>Práticas sugeridas</h3>

            <ul>
              <li>Pratique a meditação da bondade amorosa para cultivar compaixão por si mesmo e pelos outros</li>
              <li>Enfrente um medo ou desafio pequeno todos os dias para construir coragem gradualmente</li>
              <li>Experimente técnicas de respiração para manter a calma em situações estressantes</li>
              <li>Mantenha um diário de "vitórias internas", registrando momentos em que você demonstrou força interior</li>
              <li>Pratique a comunicação não-violenta para expressar-se com firmeza e compaixão</li>
            </ul>

            <h3>Afirmação da Força</h3>

            <p><i>"Eu possuo a força interior para enfrentar qualquer desafio com coragem e compaixão. Domino meus impulsos com gentileza e ajo com determinação e graça em todas as situações."</i></p>

            <p>A Força o lembra que <b>a verdadeira força reside na capacidade de agir com coragem e compaixão</b>. Esta carta o encoraja a confiar em sua força interior, a enfrentar seus medos e desafios com determinação, e a exercer influência através da gentileza e do autocontrole. Lembre-se de que a força mais poderosa é aquela que une firmeza com compaixão.</p>

            <h3>Reflexão final</h3>

            <p><i>"No coração da Força, reside a harmonia entre o leão e a donzela - o poder bruto e a gentileza compassiva. Como você pode incorporar essa dualidade em sua vida, domando seus próprios 'leões internos' com graça e coragem?"</i></p>`,
          },
          {
            id: 13,
            name: 'O Enforcado',
            image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/2/29/Jean_Dodal_Tarot_trump_12.jpg/200px-Jean_Dodal_Tarot_trump_12.jpg',
            messages: `<p>O Enforcado simboliza <b>suspensão</b>, <b>rendição</b>, <b>nova perspectiva</b> e <b>sacrifício</b>. Esta carta representa um período de pausa e reflexão, onde a inação voluntária leva a insights profundos e uma mudança radical de ponto de vista.</p>

            <h3>Reflexão sobre a energia da carta</h3>

            <p>Neste momento, você é convidado a pausar e ver o mundo de uma nova perspectiva. O Enforcado o encoraja a <i>soltar o controle, render-se ao fluxo da vida e estar aberto a insights inesperados</i>. É um período para sacrificar velhas crenças ou padrões em prol de uma compreensão mais profunda e transformadora.</p>

            <h3>Manifestações na vida real</h3>

            <ul>
              <li>Você pode se sentir "suspenso" ou em um estado de espera em alguma área da vida</li>
              <li>Situações que exigem que você "solte" o controle podem surgir</li>
              <li>Insights surpreendentes podem vir quando você menos espera</li>
              <li>Você pode ser chamado a fazer um sacrifício por um bem maior</li>
              <li>Oportunidades para ver situações familiares de um ângulo completamente novo podem aparecer</li>
            </ul>

            <h3>Pontos para consideração</h3>

            <ol>
              <li><b>Rendição vs. desistência</b>: Como você pode praticar a rendição sem desistir completamente?</li>
              <li><b>Pausa ativa</b>: De que maneira a inação pode ser uma forma de ação em sua situação atual?</li>
              <li><b>Inversão de perspectiva</b>: Que situações em sua vida poderiam se beneficiar de uma visão radicalmente diferente?</li>
              <li><b>Sacrifício consciente</b>: O que você está disposto a sacrificar para ganhar uma compreensão mais profunda ou alcançar um objetivo maior?</li>
              <li><b>Sabedoria na suspensão</b>: Que lições ou insights você pode ganhar ao "ficar suspenso" por um tempo?</li>
            </ol>

            <h3>Práticas sugeridas</h3>

            <ul>
              <li>Pratique meditação ou yoga para cultivar a arte de "estar presente" sem agir</li>
              <li>Experimente ver uma situação desafiadora de uma perspectiva completamente oposta</li>
              <li>Faça um "jejum" de algo que você normalmente considera essencial e observe os insights que surgem</li>
              <li>Pratique a técnica de "brainstorming reverso", pensando em como piorar uma situação para encontrar soluções inovadoras</li>
              <li>Mantenha um diário de "momentos suspensos", registrando insights que vêm durante períodos de pausa ou reflexão</li>
            </ul>

            <h3>Afirmação do Enforcado</h3>

            <p><i>"Eu me rendo ao fluxo da vida, confiante de que na suspensão encontro sabedoria. Estou aberto a novas perspectivas e disposto a sacrificar o que não me serve mais para crescer e evoluir."</i></p>

            <p>O Enforcado o lembra que <b>às vezes é necessário virar o mundo de cabeça para baixo para ver a verdade</b>. Esta carta o encoraja a abraçar os períodos de pausa e incerteza como oportunidades de crescimento e iluminação. Confie que ao soltar o controle e estar aberto a novas perspectivas, você ganhará insights valiosos que podem transformar sua vida.</p>

            <h3>Reflexão final</h3>

            <p><i>"Na suspensão do Enforcado, encontramos a liberdade de ver além de nossas limitações. Que novas verdades você descobrirá quando se permitir ficar de cabeça para baixo, vendo o mundo através dos olhos da rendição e da abertura?"</i></p>`,
          },
          {
            id: 14,
            name: 'A Morte',
            image: 'https://tarotfarm.com.br/wp-content/uploads/2020/12/A-Morte-.jpg',
            messages: `<p>A Morte simboliza <b>transformação</b>, <b>fim de ciclos</b>, <b>renovação</b> e <b>mudança profunda</b>. Esta carta representa o processo natural de finalização e renascimento, a necessidade de deixar ir o velho para dar espaço ao novo.</p>

            <h3>Reflexão sobre a energia da carta</h3>

            <p>Neste momento, você está no limiar de uma transformação significativa. A Morte o convida a <i>aceitar o fim de uma fase, liberar o que não serve mais e abraçar a mudança como uma oportunidade de renovação</i>. É um período para reconhecer que todo fim traz consigo o potencial de um novo começo.</p>

            <h3>Manifestações na vida real</h3>

            <ul>
              <li>Você pode estar experimentando o fim de um relacionamento, trabalho ou fase da vida</li>
              <li>Mudanças drásticas e inesperadas podem ocorrer, forçando-o a se adaptar</li>
              <li>Pode haver uma necessidade de deixar ir crenças, hábitos ou situações que não servem mais</li>
              <li>Oportunidades para reinvenção pessoal ou profissional podem surgir</li>
              <li>Você pode sentir uma forte necessidade de "limpar a casa" em vários aspectos da sua vida</li>
            </ul>

            <h3>Pontos para consideração</h3>

            <ol>
              <li><b>Aceitação da mudança</b>: Como você pode abraçar as transformações em sua vida com mais abertura e menos resistência?</li>
              <li><b>Liberação consciente</b>: O que você precisa deixar ir para criar espaço para novas oportunidades?</li>
              <li><b>Ciclos naturais</b>: Como você pode honrar os ciclos naturais de fim e recomeço em sua vida?</li>
              <li><b>Medo vs. transformação</b>: De que maneira o medo da mudança pode estar impedindo seu crescimento?</li>
              <li><b>Renascimento</b>: Que aspectos de si mesmo ou de sua vida estão prontos para uma renovação completa?</li>
            </ol>

            <h3>Práticas sugeridas</h3>

            <ul>
              <li>Realize um ritual de liberação, escrevendo o que deseja deixar para trás e queimando o papel</li>
              <li>Pratique a meditação da impermanência, refletindo sobre a natureza transitória de todas as coisas</li>
              <li>Faça uma limpeza física em seu espaço, doando ou descartando itens que não servem mais</li>
              <li>Escreva uma carta de despedida para uma fase da vida que está terminando</li>
              <li>Crie um "mapa de renascimento", visualizando como deseja se reinventar após esta transformação</li>
            </ul>

            <h3>Afirmação da Morte</h3>

            <p><i>"Eu abraço a mudança como uma oportunidade de crescimento e renovação. Libero o que não me serve mais, confiante de que cada fim traz consigo um novo e promissor começo."</i></p>

            <p>A Morte o lembra que <b>a transformação é uma parte essencial da jornada da vida</b>. Esta carta o encoraja a ver os finais não como perdas, mas como portais para novas possibilidades. Confie no processo de mudança, sabendo que ao liberar o velho, você cria espaço para que algo novo e potencialmente melhor entre em sua vida.</p>

            <h3>Reflexão final</h3>

            <p><i>"Na dança eterna da Morte e do renascimento, cada final é apenas um novo começo disfarçado. Que sementes de renovação você plantará no solo fértil da transformação que está vivenciando agora?"</i></p>`,
          },
          {
            id: 15,
            name: 'A Temperança',
            image: 'https://miro.medium.com/v2/resize:fit:1400/1*dElizSlRIOAVfEtKAvFdzw.jpeg',
            messages: `<p>A Temperança simboliza <b>equilíbrio</b>, <b>moderação</b>, <b>harmonia</b> e <b>integração</b>. Esta carta representa a capacidade de encontrar o meio-termo, combinar elementos aparentemente opostos e alcançar uma síntese harmoniosa em todos os aspectos da vida.</p>

            <h3>Reflexão sobre a energia da carta</h3>

            <p>Neste momento, você é convidado a buscar o equilíbrio e a moderação em sua vida. A Temperança o encoraja a <i>harmonizar diferentes aspectos de si mesmo, encontrar o meio-termo em situações extremas e integrar experiências aparentemente contraditórias</i>. É um período para cultivar paciência, adaptabilidade e uma abordagem equilibrada para os desafios da vida.</p>

            <h3>Manifestações na vida real</h3>

            <ul>
              <li>Você pode sentir uma necessidade de equilibrar diferentes áreas de sua vida (trabalho/lazer, mente/corpo, etc.)</li>
              <li>Situações que exigem diplomacia e a capacidade de mediar conflitos podem surgir</li>
              <li>Oportunidades para combinar ideias ou abordagens diferentes de forma criativa podem aparecer</li>
              <li>Você pode experimentar uma maior sensação de calma e equilíbrio emocional</li>
              <li>A necessidade de moderar hábitos ou comportamentos extremos pode se tornar evidente</li>
            </ul>

            <h3>Pontos para consideração</h3>

            <ol>
              <li><b>Equilíbrio dinâmico</b>: Como você pode manter o equilíbrio em um mundo em constante mudança?</li>
              <li><b>Integração de opostos</b>: Que aspectos aparentemente contraditórios de sua vida ou personalidade precisam ser harmonizados?</li>
              <li><b>Moderação vs. extremos</b>: Em quais áreas da sua vida a moderação poderia trazer mais harmonia e eficácia?</li>
              <li><b>Paciência e timing</b>: Como você pode cultivar mais paciência e um senso de timing adequado em suas ações?</li>
              <li><b>Síntese criativa</b>: De que maneiras você pode combinar diferentes ideias ou abordagens para criar algo novo e harmonioso?</li>
            </ol>

            <h3>Práticas sugeridas</h3>

            <ul>
              <li>Pratique a meditação do meio-termo, focando em encontrar equilíbrio entre extremos em sua vida</li>
              <li>Experimente a técnica da "tigela de mistura", onde você visualiza a integração harmoniosa de diferentes aspectos de sua vida</li>
              <li>Mantenha um "diário de equilíbrio", registrando momentos de harmonia e desequilíbrio em seu dia-a-dia</li>
              <li>Pratique a comunicação não-violenta para mediar conflitos de forma equilibrada</li>
              <li>Experimente uma nova atividade que combine elementos físicos e mentais, como yoga ou tai chi</li>
            </ul>

            <h3>Afirmação da Temperança</h3>

            <p><i>"Eu cultivo o equilíbrio e a harmonia em todos os aspectos da minha vida. Com paciência e moderação, integro experiências diversas, encontrando sabedoria na síntese e no meio-termo."</i></p>

            <p>A Temperança o lembra que <b>a verdadeira força reside no equilíbrio e na integração harmoniosa</b>. Esta carta o encoraja a buscar o meio-termo, a ser paciente com os processos de vida e a encontrar formas criativas de combinar elementos diferentes. Confie em sua capacidade de harmonizar, moderar e equilibrar as diversas facetas de sua existência.</p>

            <h3>Reflexão final</h3>

            <p><i>"Na dança da Temperança, cada passo é uma oportunidade de equilíbrio, cada movimento uma chance de integração. Como você pode coreografar sua vida para que cada elemento flua harmoniosamente com os outros, criando uma sinfonia de equilíbrio e moderação?"</i></p>`,
          },
          {
            id: 16,
            name: 'O Diabo',
            image: 'https://miro.medium.com/v2/resize:fit:1400/1*hw-qQCFToLxGa2MYTCRiaw.jpeg',
            messages: `<p>O Diabo simboliza <b>tentação</b>, <b>apego</b>, <b>materialismo</b> e <b>sombras internas</b>. Esta carta representa os aspectos ocultos de nós mesmos, os desejos reprimidos, e as formas como podemos nos sentir presos ou limitados por nossas próprias escolhas e crenças.</p>

<h3>Reflexão sobre a energia da carta</h3>

<p>Neste momento, você é convidado a examinar seus apegos e limitações auto-impostas. O Diabo o encoraja a <i>confrontar seus medos, reconhecer seus desejos mais profundos e questionar as crenças que o mantêm preso</i>. É um período para explorar suas sombras internas, reconhecer padrões destrutivos e buscar liberação de influências negativas.</p>

<h3>Manifestações na vida real</h3>

<ul>
  <li>Você pode se sentir tentado por prazeres imediatos ou escolhas que vão contra seus valores de longo prazo</li>
  <li>Padrões de comportamento autodestrutivos ou vícios podem se tornar mais evidentes</li>
  <li>Questões relacionadas a dinheiro, poder ou desejo sexual podem vir à tona</li>
  <li>Você pode se sentir "acorrentado" a uma situação, relacionamento ou crença limitante</li>
  <li>Aspectos sombrios de sua personalidade ou desejos reprimidos podem buscar expressão</li>
</ul>

<h3>Pontos para consideração</h3>

<ol>
  <li><b>Apegos vs. liberdade</b>: Quais apegos em sua vida estão realmente limitando seu crescimento e liberdade?</li>
  <li><b>Sombras internas</b>: Que aspectos de si mesmo você teme ou reprime, e como pode integrá-los de forma saudável?</li>
  <li><b>Tentação e autodisciplina</b>: Como você pode desenvolver mais autodisciplina diante de tentações que não servem seu bem maior?</li>
  <li><b>Crenças limitantes</b>: Quais crenças sobre si mesmo ou sobre o mundo estão impedindo seu progresso?</li>
  <li><b>Poder pessoal</b>: Como você pode reclamar seu poder em áreas onde se sente impotente ou controlado externamente?</li>
</ol>

<h3>Práticas sugeridas</h3>

<ul>
  <li>Pratique a meditação de confronto com a sombra, visualizando e dialogando com seus aspectos reprimidos</li>
  <li>Mantenha um "diário das tentações", registrando impulsos e refletindo sobre suas origens mais profundas</li>
  <li>Experimente a técnica de "reescrita de crenças", identificando e transformando crenças limitantes</li>
  <li>Pratique a gratidão diária para equilibrar tendências materialistas</li>
  <li>Busque terapia ou aconselhamento para trabalhar questões profundas relacionadas a vícios ou padrões destrutivos</li>
</ul>

<h3>Afirmação do Diabo</h3>

<p><i>"Eu reconheço e aceito todos os aspectos de mim mesmo. Liberto-me de apegos e limitações auto-impostas, reclamando meu poder e escolhendo conscientemente meu caminho."</i></p>

<p>O Diabo o lembra que <b>a verdadeira liberdade vem do autoconhecimento e da aceitação de todos os aspectos de si mesmo</b>. Esta carta o encoraja a olhar honestamente para suas sombras, reconhecer seus desejos mais profundos e questionar as estruturas que o limitam. Ao confrontar seus medos e tentações, você pode transformar essa energia em criatividade e poder pessoal.</p>

<h3>Reflexão final</h3>

<p><i>"Nas profundezas do reino do Diabo, encontramos as chaves para nossa própria libertação. Que correntes você está pronto para quebrar, e que poder oculto você descobrirá ao abraçar todas as facetas de seu ser?"</i></p>`,
          },
          {
            id: 17,
            name: 'A Torre',
            image: 'https://miro.medium.com/v2/resize:fit:1400/1*tZQNRBY7lN2AkjaMxOW9yw.jpeg',
            messages: `<p>A Torre simboliza <b>ruptura súbita</b>, <b>revelação</b>, <b>caos</b> e <b>libertação</b>. Esta carta representa momentos de crise e mudança repentina que, embora inicialmente perturbadores, levam à libertação de velhas estruturas e crenças limitantes.</p>

            <h3>Reflexão sobre a energia da carta</h3>

            <p>Neste momento, você pode estar enfrentando ou prestes a enfrentar uma mudança dramática e inesperada. A Torre o convida a <i>aceitar a destruição do que não é mais sustentável em sua vida, permitindo que novas verdades e realidades emerjam das ruínas</i>. É um período de desafio, mas também de profunda transformação e liberação.</p>

            <h3>Manifestações na vida real</h3>

            <ul>
              <li>Eventos súbitos e inesperados podem abalar as fundações de sua vida</li>
              <li>Verdades ocultas ou negadas podem vir à tona de maneira abrupta</li>
              <li>Estruturas, relacionamentos ou situações instáveis podem desmoronar</li>
              <li>Você pode experimentar uma mudança repentina de perspectiva ou crença</li>
              <li>Oportunidades para liberação e reconstrução podem surgir após momentos de crise</li>
            </ul>

            <h3>Pontos para consideração</h3>

            <ol>
              <li><b>Resistência vs. aceitação</b>: Como você pode abraçar a mudança ao invés de resistir a ela, mesmo quando é desconfortável?</li>
              <li><b>Verdades reveladas</b>: Que revelações ou insights estão emergindo através desta ruptura?</li>
              <li><b>Libertação de estruturas limitantes</b>: Quais aspectos de sua vida precisavam ser "demolidos" para dar espaço ao novo?</li>
              <li><b>Oportunidade na adversidade</b>: Como você pode transformar este momento de crise em uma oportunidade de crescimento?</li>
              <li><b>Reconstrução consciente</b>: Que novas fundações você deseja estabelecer após esta ruptura?</li>
            </ol>

            <h3>Práticas sugeridas</h3>

            <ul>
              <li>Pratique a meditação de "deixar ir", visualizando-se liberando apegos a estruturas ou crenças antigas</li>
              <li>Mantenha um "diário de transformação", documentando insights e mudanças durante este período turbulento</li>
              <li>Experimente a técnica de "visualização da fênix", imaginando-se renascendo das cinzas da situação atual</li>
              <li>Pratique exercícios de respiração profunda para manter o equilíbrio durante momentos de estresse ou choque</li>
              <li>Crie um "mapa de reconstrução", planejando como deseja reconstruir aspectos de sua vida após a ruptura</li>
            </ul>

            <h3>Afirmação da Torre</h3>

            <p><i>"Eu abraço a mudança e a transformação, mesmo quando são abruptas. Das ruínas do velho, construo novas fundações mais alinhadas com minha verdadeira essência e propósito."</i></p>

            <p>A Torre o lembra que <b>às vezes a destruição é necessária para o verdadeiro crescimento e libertação</b>. Esta carta o encoraja a ver os momentos de crise como oportunidades de quebrar padrões limitantes e falsas crenças. Confie que, após a tempestade, virá a clareza e a chance de reconstruir algo mais autêntico e alinhado com seu verdadeiro eu.</p>

            <h3>Reflexão final</h3>

            <p><i>"No relâmpago da Torre, vemos brevemente a verdade nua e crua. Que ilusões estão sendo despedaçadas em sua vida, e que nova realidade, mais autêntica e livre, está emergindo dos escombros?"</i></p>`,
          },
          {
            id: 18,
            name: 'A Estrela',
            image: 'https://mkt.wemystic.net/design/landings/wmbr/conselho-tarot/arcanos-maiores/a-estrela.jpg',
            messages: `<p>A Estrela simboliza <b>esperança</b>, <b>inspiração</b>, <b>renovação</b> e <b>serenidade</b>. Esta carta representa um período de cura, otimismo e conexão com o universo, trazendo luz após tempos de escuridão e dificuldade.</p>

            <h3>Reflexão sobre a energia da carta</h3>

            <p>Neste momento, você é convidado a renovar sua fé e esperança. A Estrela o encoraja a <i>abrir seu coração para as possibilidades infinitas do universo, confiar no fluxo da vida e reconectar-se com seu propósito e inspiração</i>. É um período de cura emocional, de encontrar serenidade em meio ao caos e de se alinhar com sua verdadeira essência.</p>

            <h3>Manifestações na vida real</h3>

            <ul>
              <li>Você pode sentir uma renovada sensação de esperança e otimismo sobre o futuro</li>
              <li>Inspiração criativa e ideias inovadoras podem fluir mais facilmente</li>
              <li>Oportunidades de cura emocional e física podem se apresentar</li>
              <li>Você pode se sentir mais conectado com a natureza e o universo</li>
              <li>Um senso de calma e serenidade pode permear suas experiências, mesmo em tempos difíceis</li>
            </ul>

            <h3>Pontos para consideração</h3>

            <ol>
              <li><b>Renovação da esperança</b>: Como você pode cultivar e manter a esperança, especialmente após períodos desafiadores?</li>
              <li><b>Inspiração e criatividade</b>: Que projetos ou ideias inspiradoras você gostaria de explorar?</li>
              <li><b>Cura e autoaceitação</b>: Quais aspectos de si mesmo precisam de cura e aceitação compassiva?</li>
              <li><b>Conexão com o universo</b>: Como você pode se sentir mais conectado com o mundo ao seu redor e com seu propósito maior?</li>
              <li><b>Generosidade e abundância</b>: De que maneiras você pode compartilhar seus dons e abundância com os outros?</li>
            </ol>

            <h3>Práticas sugeridas</h3>

            <ul>
              <li>Pratique a meditação da estrela guia, visualizando uma luz brilhante guiando seu caminho</li>
              <li>Mantenha um "diário de gratidão estelar", registrando diariamente momentos de beleza e inspiração</li>
              <li>Experimente banhos de lua ou observação de estrelas para se conectar com a energia cósmica</li>
              <li>Crie um "altar de esperança", reunindo objetos que simbolizam seus sonhos e aspirações</li>
              <li>Pratique atos de bondade aleatórios, compartilhando sua luz interior com os outros</li>
            </ul>

            <h3>Afirmação da Estrela</h3>

            <p><i>"Eu me abro para a esperança e a inspiração do universo. Confio no fluxo da vida, sabendo que sou guiado e apoiado em minha jornada de cura e renovação."</i></p>

            <p>A Estrela o lembra que <b>mesmo nos momentos mais escuros, há sempre uma luz guiando o caminho</b>. Esta carta o encoraja a manter a fé, a se abrir para a beleza e as possibilidades ao seu redor, e a confiar que o universo está trabalhando a seu favor. Permita-se ser inspirado e inspire os outros com sua luz interior.</p>

            <h3>Reflexão final</h3>

            <p><i>"No vasto céu noturno da existência, você é uma estrela brilhante, única em seu brilho. Que luz você escolhe irradiar para o mundo, e como essa luz pode guiar não apenas seu caminho, mas também iluminar o caminho dos outros?"</i></p>`,
          },
          {
            id: 19,
            name: 'A Lua',
            image: 'https://miro.medium.com/v2/resize:fit:1400/1*9yhC9lMC_tP1fqDUprll8A.jpeg',
            messages: `<p>A Lua simboliza <b>intuição</b>, <b>ilusão</b>, <b>emoções profundas</b> e <b>o subconsciente</b>. Esta carta representa o reino do oculto, dos sonhos e das sombras internas, convidando-nos a explorar as profundezas de nossa psique e confiar em nossa sabedoria intuitiva.</p>

            <h3>Reflexão sobre a energia da carta</h3>

            <p>Neste momento, você é chamado a mergulhar nas águas profundas de seu subconsciente. A Lua o encoraja a <i>confiar em sua intuição, enfrentar seus medos e ilusões, e navegar pelo desconhecido com coragem e discernimento</i>. É um período para explorar seus sonhos, reconhecer padrões emocionais ocultos e abraçar os mistérios da vida.</p>

            <h3>Manifestações na vida real</h3>

            <ul>
              <li>Você pode experimentar sonhos vívidos ou insights intuitivos poderosos</li>
              <li>Emoções intensas ou memórias reprimidas podem vir à tona</li>
              <li>Situações confusas ou ilusórias podem desafiar sua percepção da realidade</li>
              <li>Sua sensibilidade e empatia podem estar intensificadas</li>
              <li>Você pode sentir uma forte atração pelo místico, oculto ou inexplicável</li>
            </ul>

            <h3>Pontos para consideração</h3>

            <ol>
              <li><b>Intuição vs. medo</b>: Como você pode diferenciar entre intuição genuína e medos infundados?</li>
              <li><b>Confronto com sombras</b>: Que aspectos de sua sombra interna você está pronto para reconhecer e integrar?</li>
              <li><b>Ilusão e realidade</b>: Em quais áreas de sua vida você pode estar se iludindo ou vendo apenas parte da verdade?</li>
              <li><b>Navegação emocional</b>: Como você pode navegar com mais confiança através de emoções intensas ou confusas?</li>
              <li><b>Sabedoria dos sonhos</b>: Que mensagens seus sonhos ou seu subconsciente estão tentando lhe transmitir?</li>
            </ol>

            <h3>Práticas sugeridas</h3>

            <ul>
              <li>Mantenha um diário de sonhos, registrando e refletindo sobre seus sonhos noturnos</li>
              <li>Pratique meditação guiada focada em explorar seu subconsciente</li>
              <li>Experimente técnicas de arteterapia para expressar emoções e insights intuitivos</li>
              <li>Realize rituais de lua cheia para sintonizar-se com os ciclos naturais e sua intuição</li>
              <li>Pratique a técnica de "diálogo com a sombra", conversando com aspectos ocultos de si mesmo</li>
            </ul>

            <h3>Afirmação da Lua</h3>

            <p><i>"Eu confio em minha intuição e abraço os mistérios do meu ser interior. Navego pelas águas do desconhecido com coragem, sabendo que a luz da consciência ilumina meu caminho."</i></p>

            <p>A Lua o lembra que <b>nem tudo é o que parece à primeira vista, e que a verdade muitas vezes reside além das aparências</b>. Esta carta o encoraja a confiar em sua sabedoria interior, a explorar o desconhecido com curiosidade e a encontrar beleza e significado nos mistérios da vida. Permita-se ser guiado pela luz suave da Lua através das sombras de seu ser.</p>

            <h3>Reflexão final</h3>

            <p><i>"Na penumbra do reino lunar, as fronteiras entre o real e o imaginário se dissolvem. Que verdades profundas você descobrirá ao mergulhar nas águas prateadas de seu subconsciente, e como essas revelações iluminarão seu caminho no mundo desperto?"</i></p>`,
          },
          {
            id: 20,
            name: 'O Sol',
            image: 'https://miro.medium.com/v2/resize:fit:1400/1*gy3J4xteMlcfY1B5FKFsoA.jpeg',
            messages: `<p>O Sol simboliza <b>alegria</b>, <b>vitalidade</b>, <b>sucesso</b> e <b>clareza</b>. Esta carta representa a luz da consciência, a energia positiva e o triunfo sobre a adversidade, trazendo calor, crescimento e iluminação para todos os aspectos da vida.</p>

            <h3>Reflexão sobre a energia da carta</h3>

            <p>Neste momento, você é convidado a abraçar a luz e a alegria em sua vida. O Sol o encoraja a <i>celebrar suas conquistas, expressar sua autenticidade e irradiar positividade para o mundo ao seu redor</i>. É um período de clareza mental, confiança e realização pessoal, onde você pode brilhar em todo o seu potencial.</p>

            <h3>Manifestações na vida real</h3>

            <ul>
              <li>Você pode experimentar um aumento significativo em sua energia e entusiasmo</li>
              <li>Sucessos e reconhecimentos podem chegar em várias áreas de sua vida</li>
              <li>Relacionamentos podem florescer com mais harmonia e alegria</li>
              <li>Você pode sentir uma maior clareza sobre seus objetivos e direção na vida</li>
              <li>Oportunidades para crescimento pessoal e profissional podem se apresentar</li>
            </ul>

            <h3>Pontos para consideração</h3>

            <ol>
              <li><b>Autenticidade e expressão</b>: Como você pode expressar sua verdadeira essência de forma mais plena e autêntica?</li>
              <li><b>Celebração e gratidão</b>: Quais aspectos positivos de sua vida merecem ser celebrados e apreciados?</li>
              <li><b>Clareza e propósito</b>: Com a clareza que o Sol traz, quais são seus verdadeiros objetivos e aspirações?</li>
              <li><b>Vitalidade e bem-estar</b>: Como você pode nutrir sua saúde física e mental para manter essa energia positiva?</li>
              <li><b>Inspiração para os outros</b>: De que maneiras você pode usar sua luz interior para inspirar e elevar aqueles ao seu redor?</li>
            </ol>

            <h3>Práticas sugeridas</h3>

            <ul>
              <li>Pratique a "saudação ao sol" diariamente, conectando-se com a energia solar e vitalizante</li>
              <li>Mantenha um "diário de luz", registrando momentos de alegria, sucesso e clareza em sua vida</li>
              <li>Crie um "mapa de visão solar", visualizando e planejando seus objetivos mais brilhantes</li>
              <li>Dedique tempo para atividades ao ar livre, absorvendo a luz natural e a energia da natureza</li>
              <li>Pratique atos de bondade e generosidade, compartilhando sua luz com os outros</li>
            </ul>

            <h3>Afirmação do Sol</h3>

            <p><i>"Eu brilho com confiança e alegria, abraçando minha luz interior. Minha clareza e vitalidade iluminam meu caminho e inspiram aqueles ao meu redor."</i></p>

            <p>O Sol o lembra que <b>você tem dentro de si uma fonte inesgotável de luz e potencial</b>. Esta carta o encoraja a confiar em sua capacidade de superar desafios, a celebrar suas conquistas e a irradiar positividade. Permita que a luz do Sol dissipe quaisquer dúvidas ou sombras, revelando o caminho para sua realização e felicidade.</p>

            <h3>Reflexão final</h3>

            <p><i>"No esplendor radiante do Sol, todas as possibilidades se revelam. Que sementes de potencial você escolherá nutrir sob esta luz vivificante, e como o calor de sua própria luz interior transformará não apenas sua vida, mas o mundo ao seu redor?"</i></p>`,
          },
          {
            id: 21,
            name: 'O Julgamento',
            image: 'https://miro.medium.com/v2/resize:fit:1400/1*jHdK8din0To2kwXY2KU5vg.jpeg',
            messages: `<p>O Julgamento simboliza <b>despertar</b>, <b>renovação</b>, <b>chamado interior</b> e <b>transformação</b>. Esta carta representa um momento de avaliação profunda, onde somos chamados a examinar nossas vidas, fazer escolhas importantes e renascer para um novo nível de consciência.</p>

            <h3>Reflexão sobre a energia da carta</h3>

            <p>Neste momento, você é convidado a ouvir o chamado de sua verdadeira vocação. O Julgamento o encoraja a <i>refletir honestamente sobre seu passado, reconhecer seu potencial não realizado e abraçar uma transformação profunda</i>. É um período de despertar espiritual, de perdão (de si mesmo e dos outros) e de alinhamento com seu propósito maior.</p>

            <h3>Manifestações na vida real</h3>

            <ul>
              <li>Você pode sentir um forte impulso para mudanças significativas em sua vida</li>
              <li>Insights profundos sobre seu passado e seu propósito podem surgir</li>
              <li>Oportunidades para perdoar a si mesmo e aos outros podem se apresentar</li>
              <li>Você pode sentir um chamado para uma missão ou propósito maior</li>
              <li>Decisões importantes que afetarão seu futuro podem precisar ser tomadas</li>
            </ul>

            <h3>Pontos para consideração</h3>

            <ol>
              <li><b>Autoavaliação honesta</b>: Que aspectos de sua vida precisam de uma revisão sincera e profunda?</li>
              <li><b>Chamado interior</b>: Que voz ou impulso interno você tem ignorado e que agora pede atenção?</li>
              <li><b>Perdão e liberação</b>: O que você precisa perdoar ou liberar para avançar em sua jornada?</li>
              <li><b>Alinhamento com o propósito</b>: Como suas ações atuais se alinham com seu senso de propósito maior?</li>
              <li><b>Renascimento</b>: Que versão de si mesmo está pronta para emergir nesta nova fase de sua vida?</li>
            </ol>

            <h3>Práticas sugeridas</h3>

            <ul>
              <li>Pratique a meditação do "chamado interior", focando em ouvir sua voz interna e intuição</li>
              <li>Escreva uma carta de perdão para si mesmo ou para alguém que precise de cura em sua vida</li>
              <li>Crie um "inventário de vida", avaliando honestamente diferentes áreas de sua existência</li>
              <li>Realize um ritual de renascimento simbólico, como um banho purificador ou uma cerimônia de renovação</li>
              <li>Desenvolva um "plano de ação de propósito", alinhando suas metas com seu chamado interior</li>
            </ul>

            <h3>Afirmação do Julgamento</h3>

            <p><i>"Eu ouço e respondo ao chamado de minha verdadeira essência. Abraço a transformação, perdoo o passado e me renovo para alinhar-me com meu propósito maior."</i></p>

            <p>O Julgamento o lembra que <b>cada momento oferece uma oportunidade de renascimento e alinhamento com seu eu superior</b>. Esta carta o encoraja a enfrentar sua verdade, fazer as mudanças necessárias e responder ao chamado de sua alma. Confie no processo de transformação, sabendo que ele o leva a uma versão mais autêntica e realizada de si mesmo.</p>

            <h3>Reflexão final</h3>

            <p><i>"No grande despertar do Julgamento, somos chamados a prestar contas não a um poder externo, mas à voz de nossa própria alma. Que verdades você está pronto para enfrentar, que potencial está pronto para abraçar, e como você responderá ao chamado de seu eu mais elevado?"</i></p>`,
          },
          {
            id: 22,
            name: 'O Mundo',
            image: 'https://miro.medium.com/v2/resize:fit:1400/1*D9PKZbrNGWwtIUKU1QJCMA.jpeg',
            messages: `<p>O Mundo simboliza <b>realização</b>, <b>completude</b>, <b>integração</b> e <b>harmonia universal</b>. Esta carta representa o fim bem-sucedido de um ciclo importante, a sensação de plenitude e a compreensão de nosso lugar no grande esquema das coisas.</p>

<h3>Reflexão sobre a energia da carta</h3>

<p>Neste momento, você é convidado a celebrar suas conquistas e reconhecer a jornada que o trouxe até aqui. O Mundo o encoraja a <i>integrar todas as suas experiências, abraçar um senso de completude e se abrir para novas possibilidades em um nível mais elevado</i>. É um período de realização, gratidão e compreensão da interconexão de todas as coisas.</p>

<h3>Manifestações na vida real</h3>

<ul>
  <li>Você pode experimentar um forte senso de realização em uma área importante da vida</li>
  <li>Projetos de longo prazo podem chegar a uma conclusão bem-sucedida</li>
  <li>Você pode sentir uma maior compreensão de seu lugar no mundo e sua conexão com os outros</li>
  <li>Oportunidades de viagem ou expansão de horizontes podem surgir</li>
  <li>Você pode sentir uma harmonia entre diferentes aspectos de sua vida</li>
</ul>

<h3>Pontos para consideração</h3>

<ol>
  <li><b>Celebração e gratidão</b>: Como você pode honrar e celebrar adequadamente suas realizações?</li>
  <li><b>Integração de experiências</b>: Que lições de sua jornada você pode integrar para avançar com sabedoria?</li>
  <li><b>Conexão universal</b>: Como você pode aprofundar sua compreensão da interconexão de todas as coisas?</li>
  <li><b>Novos horizontes</b>: Que novas aventuras ou desafios você está pronto para abraçar?</li>
  <li><b>Equilíbrio e harmonia</b>: Como você pode manter um senso de equilíbrio enquanto se move para o próximo capítulo de sua vida?</li>
</ol>

<h3>Práticas sugeridas</h3>

<ul>
  <li>Crie um "mapa de jornada", ilustrando visualmente sua trajetória e realizações até o momento</li>
  <li>Pratique a meditação de "conexão universal", visualizando-se como parte integrante do cosmos</li>
  <li>Realize um ritual de gratidão, agradecendo a todas as pessoas e experiências que contribuíram para sua jornada</li>
  <li>Escreva uma "carta para o futuro", definindo suas aspirações para o próximo ciclo de sua vida</li>
  <li>Participe de uma atividade que celebre a diversidade cultural e a unidade global</li>
</ul>

<h3>Afirmação do Mundo</h3>

<p><i>"Eu celebro minhas realizações e abraço minha completude. Reconheço minha conexão com o todo e me abro para novas possibilidades com gratidão e harmonia."</i></p>

<p>O Mundo o lembra que <b>cada fim é também um novo começo, e que você faz parte de um todo maior e interconectado</b>. Esta carta o encoraja a reconhecer suas conquistas, integrar suas experiências e se preparar para novos ciclos de crescimento e exploração. Confie na jornada contínua da vida, sabendo que você está sempre evoluindo e se expandindo.</p>

<h3>Reflexão final</h3>

<p><i>"No grande palco do Mundo, cada um de nós desempenha um papel único e essencial. Ao concluir este capítulo de sua jornada, que nova dança você está pronto para começar, e como sua performance individual contribuirá para a sinfonia cósmica da existência?"</i></p>`,
          },
        ],
        stepOne: true,
        stepTwo: false

      };
    },
    mounted(){
      this.iniciarSorteio();
    },
    methods: {
      recarregarPagina() {
        // Fade out before reload
        document.body.style.opacity = '0';
        setTimeout(() => {
          window.location.reload();
        }, 300);
      },
      nextStep(){
        this.stepOne = false;
        this.stepTwo = true;
      },
      createSparkles(event) {
        const card = event.currentTarget;
        const sparkleCount = 10;

        for (let i = 0; i < sparkleCount; i++) {
            const sparkle = document.createElement('div');
            sparkle.classList.add('sparkle');

            // Posiciona as faíscas aleatoriamente ao redor da carta
            sparkle.style.left = `${Math.random() * card.offsetWidth}px`;
            sparkle.style.top = `${Math.random() * card.offsetHeight}px`;

            card.appendChild(sparkle);

            // Remove a faísca após a animação
            setTimeout(() => {
                card.removeChild(sparkle);
            }, 500);
        }
      },
      iniciarSorteio() {
        // Sorteia as cartas
        this.cards = this.sortearCartas();
      },
      sortearCartas() {
        const baralho = [...this.cards];
        const cartasSorteadas = [];
        
        while (cartasSorteadas.length < 12) {
          const indiceAleatorio = Math.floor(Math.random() * baralho.length);
          const cartaSorteada = baralho.splice(indiceAleatorio, 1)[0];
          cartasSorteadas.push(cartaSorteada);
        }
        
        return cartasSorteadas;
      },
      embaralharCartas() {
        // Remove qualquer seleção anterior
        this.selectedCards = [];

        // Remove classe de carta selecionada
        const cardContainer = document.querySelector('.card-container');
        const cards = document.querySelectorAll('.card');

        // Adiciona classe de animação
        cardContainer.classList.add('shuffling');
        
        cards.forEach((cardEl, index) => {
          cardEl.classList.remove('selected', 'fade-out');
          
          // Animação circular com delay para cada carta
          cardEl.style.animation = `shuffleCircle 1s ease-in-out ${index * 0.1}s forwards`;
        });

        // Reordena as cartas após a animação
        setTimeout(() => {
          this.cards = this.sortearCartas();

          // Remove animações
          cards.forEach(cardEl => {
            cardEl.style.animation = 'none';
          });

          cardContainer.classList.remove('shuffling');
        }, 2000);
      },
      selectCard(card, event) {
        // Verifique se o número máximo de seleções não foi atingido e se a carta não foi selecionada ainda
        if (this.selectedCards.length < this.maxSelections && !this.selectedCards.some(selected => selected.id === card.id)) {
          this.selectedCards.push(card);

           // Remove a classe 'selected' de todas as cartas
          const cards = document.querySelectorAll('.card');
          cards.forEach(cardEl => {
              cardEl.classList.remove('selected');
          });
          
          const selectedCardEl = event.currentTarget;
          selectedCardEl.classList.add('selected');

          // Cria faíscas
          this.createSparkles(event);

          // Adiciona fadeOut após 1 segundo
          setTimeout(() => {
              // Usa um seletor mais amplo
              const cardContainer = document.querySelector('.card-container');
              const botaoEmbaralhar = document.querySelector('.btn-embaralhar');
              console.log(cardContainer);
              if (cardContainer) {
                  cardContainer.classList.add('fade-out');
                  botaoEmbaralhar.classList.add('fade-out');
              }
          }, 1000);


          this.$nextTick(() => {
            const container = document.querySelector('.carta-detalhes-container');
            if (container) {
              container.style.opacity = '0';
              container.style.transform = 'scale(0.9)';
              setTimeout(() => {
                container.style.opacity = '1';
                container.style.transform = 'scale(1)';
              }, 50);
            }
          });

          this.enviarEmail();

          console.log(this.selectedCards); // Agora `selectedCards` armazena os objetos `card` completos
        }
      },
      async fetchTagsByEmail() {
        this.loading = true;
        const url = `https://verificatag-ag.mahilaluz.workers.dev?email=${encodeURIComponent(this.email)}`;

        try {
          const response = await axios.post(url);

          this.tags = response.data;
          this.enviarEmail();
        } catch (error) {
          console.error('Failed to fetch tags:', error);
        }
      },
      async enviarEmail() {
        const brevoApiKey =
          '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';

        //outra chave: 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

        // Configurar o payload da API da Brevo
        const data = {
          sender: {
            email: 'contato@mahilaluz.com',
            name: 'Mahila Luz'
          },
          to: [{
              email: this.email
            },
            {
              email: 'contato@mahilaluz.com'
            } // Adicione seu próprio e-mail aqui
          ],
          subject: 'Resultado da sua Tiragem',
          htmlContent: '<p>Oii. Tudo bem? <br><br>Aqui está o resultado da sua tiragem.<br><br>Pergunta feita: '+ this.pergunta +'<br><br> Resultado da Tiragem:' + this.selectedCards[0].messages + '<br>Qualquer dúvida pode me chamar aqui. <br><br> Muita luz para você💜💜</p>',
          //scheduledAt: sendAt
        };

        // Configurar os headers da requisição
        const config = {
          headers: {
            'Content-Type': 'application/json',
            'api-key': brevoApiKey
          }
        };

        try {
          const response = await axios.post('https://api.brevo.com/v3/smtp/email', data, config);
          console.log('Email scheduled successfully:', response.data);

        } catch (error) {
          console.error('Error scheduling email:', error);
        }
      },  
    },
  }
</script>